import gql from "graphql-tag";

export const getChatConversationMessagesQuery = gql`
    query GetChatConversationMessages($getMessageDto: GetMessageDto!) {
        getChatConversationMessages(getMessageDto: $getMessageDto) {
            messages {
                id
                created
                text
                sender {
                    id
                }
                deleted
                isSenderBlocked
                richContent {
                    dynamicMessage {
                        templateId
                    }
                }
            }
            hasMore
        }
    }
`;
